import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ClientProcessingError } from 'app/_errors/client-processing.error';
import { UnknownApplicationError } from 'app/_errors/unknown-application.error';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../../environments/environment';

export interface SiteRequiredCompetencyDTO {
  id: number;
  siteId: number;
  competencyTypeId: number;
  competencyTypeName: string;
  competencyType: string;
  createdDate: string;
  updateDate: string;
}

export interface CreateSiteRequiredCompetencyDTO {
  siteId: number;
  competencyTypeId: number;
}

@Injectable()
export class SiteRequiredCompetencyService {

  constructor(private http: HttpClient) { }

  public getBySite(siteId: number): Observable<SiteRequiredCompetencyDTO[]> {
    return this.http
      .get<SiteRequiredCompetencyDTO[]>(environment.competencyApiUrl + 'api/site-required-competency/by-site/' + siteId)
      .pipe(catchError(this.handleError));
  }

  public createMultiple(items: CreateSiteRequiredCompetencyDTO[]): Observable<SiteRequiredCompetencyDTO[]> {
    return this.http
      .post<SiteRequiredCompetencyDTO[]>(environment.competencyApiUrl + 'api/site-required-competency/multiple', items)
      .pipe(catchError(this.handleError));
  }

  public delete(id: number): Observable<void> {
    return this.http
      .delete<void>(environment.competencyApiUrl + 'api/site-required-competency/' + id)
      .pipe(catchError(this.handleError));
  }

  private handleError(error: any) {
    if (error instanceof HttpErrorResponse) {
      return throwError(error);
    }

    if (error instanceof Error) {
      return throwError(
        new ClientProcessingError('The application could not process the server response.', error)
      );
    }

    return throwError(
      new UnknownApplicationError('The application threw an unknown error value.', error)
    );
  }
}
